import React, { useState, useEffect, useRef } from 'react';
//import Lottie from 'react-lottie';
import Lottie from "lottie-web";
//import doItLottie from '../bin/images/doitanimation.json'

import HomeTopHeroUnit from '../components/HomeTopHeroUnit.js';
import HomeTopHeroUnitPromotional from '../components/homeTopHeroUnitPromotional.js';
import global from '../css/Global.module.css';
import LanguageIcon from '@mui/icons-material/Language';
import GradeIcon from '@mui/icons-material/Grade';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TemperatureSalesBox from '../components/TemperatureSalesBox.js';
import headshot1 from '../bin/images/headshot1.jpeg';
import headshot2 from '../bin/images/headshot2.jpeg';
import headshot3 from '../bin/images/headshot3.jpeg';
import FeatureDisplayBoxInner from '../components/FeatureDisplayBoxInner.js';
import youWayEveryWay from '../bin/images/yourWayEveryWay.png';
import multiplatformAccess from '../bin/images/multiplatformAccess.png';
import bilingualExperience from '../bin/images/bilingualExperience.png';
import yourWayEveryWay from '../bin/images/home_your_way_every_way.png';
import PathConstants from '../routes/pathConstants.js';
import homeHeroLeft from '../bin/images/home_heroUnit_left.png';
import homeHeroRight from '../bin/images/homepage_hand.svg';
import alwaysConnected from '../bin/images/temperature_monitoring_always_connected.png';

function Home() {
  // State to keep track of the feature display box visibility and the active feature
  const [displayBoxShow, setDisplayBoxShow] = useState(false);
  const [activeFeatureDisplayBox, setActiveFeatureDisplayBox] = useState('shifts');

  // Handler for mouse enter event
  const displayBoxHandler = (feature) => {
    setDisplayBoxShow(true); // Show the display box
    setActiveFeatureDisplayBox(feature); // Set the active feature
  };

  const container = useRef(null);
  const animationInstance = useRef(null);

  useEffect(() => {
    animationInstance.current = Lottie.loadAnimation({
      container: container.current,
      loop: false,
      autoplay: false,
      keepLastFrame: true,
      animationData: require('../bin/images/doitanimation.json'),
      /*rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }*/
    });

    // Function to play the animation and set it up to play every 3 seconds
    const playAnimation = () => {
      animationInstance.current.play();

      // Set a timeout to play the animation again after 3 seconds
      setTimeout(() => {
        animationInstance.current.stop();
        playAnimation();
      }, 5000);
    };

    // Start the initial animation after a delay
    playAnimation();

    return () => {
      animationInstance.current.destroy();
    };
  }, []);




  return (
      <div className={[global.contentBody, global.homePage].join(' ')}>
      <section className={global.promoHero}>
        <div className={global.promoHeroInner}>
          <div className={global.promoHeroLeft}>
            <img src={homeHeroLeft} alt="VSBL Mobile alert" />
            <div className={global.promoLeftCaption}>No Pairing<br />Required!</div>
          </div>

          <div className={global.promoHeroCenter}>
            <div className={global.promoBadge}>New!</div>

            <h1 className={global.promoH1}>VSBL with Remote Temperature Monitoring</h1>

            <p className={global.promoSubtitle}>
              Get the entire VSBL ecosystem <span className={global.promoPlus}>plus</span>
              <br />
              8 Temperature Sensors and a Cellular Gateway
            </p>

            <div className={global.promoOffer}>Limited Time Offer!</div>

            <div className={global.promoPriceRow}>
              <span className={global.promoOldPrice}>$249</span>
              <span className={global.promoPrice}>$199/month + tax</span>
            </div>

            <div className={global.promoSmall}>New &amp; Existing Customers Eligible</div>

            <div className={global.promoCTA}>
              <a className={global.SignUpButtonHomeHeroUnit} href={PathConstants.SignUp}>Sign Up</a>
            </div>
          </div>

          <div className={global.promoHeroRight}>
            <img src={homeHeroRight} alt="Temperature sensor in hand" />
            <div className={global.promoRightCaption}>Sensors with<br />15-Year Battery Life!</div>
          </div>
        </div>
      </section>

      <div className={global.homeh2}>
        <h2>Learn about our new partnership with Ecolab <br />
          and Remote Temperature Monitoring offer</h2>
      </div>

      <div className={global.centerVideoFrame}>
        <div className={global.centerVideoFrameContainer}>
          <iframe
            src="https://www.youtube.com/embed/tlHGtctiyXw?si=QdpE5ZgUe2hzWPGt"
            title="Exciting VSBL Announcement!"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
        </div>
      </div>

      <div className={global.featureH2}><h2>What makes our temperature sensors superior?</h2></div>

      <div className={`${global.prosList} ${global.prosListFeaturePage}`}>
        <div className={[global.prosBox, global.bilingualExperience].join(' ')}>
          <div className={global.prosIcon}>
            <div className={global.prosIconWidth}>
              <svg width="52" height="53" viewBox="0 0 52 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_148_10103" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="52" height="53">
                  <rect y="0.5" width="52" height="52" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_148_10103)">
                  <path d="M8.66687 39.5C6.86131 39.5 5.32659 38.8681 4.0627 37.6042C2.79881 36.3403 2.16687 34.8056 2.16687 33V20C2.16687 18.1944 2.79881 16.6597 4.0627 15.3958C5.32659 14.1319 6.86131 13.5 8.66687 13.5H37.9169C39.7224 13.5 41.2571 14.1319 42.521 15.3958C43.7849 16.6597 44.4169 18.1944 44.4169 20V33C44.4169 34.8056 43.7849 36.3403 42.521 37.6042C41.2571 38.8681 39.7224 39.5 37.9169 39.5H8.66687ZM46.5835 31.9167V21.0833H47.6669C48.2808 21.0833 48.7953 21.291 49.2106 21.7063C49.6259 22.1215 49.8335 22.6361 49.8335 23.25V29.75C49.8335 30.3639 49.6259 30.8785 49.2106 31.2938C48.7953 31.709 48.2808 31.9167 47.6669 31.9167H46.5835Z" fill="#1C1B1F" />
                </g>
              </svg>
            </div>
          </div>
          <div className={global.prosTitle}>15-Year Battery Life</div>
          <div className={global.prosBlurb}>Our sensors require little to no maintenance, helping you lower operational costs.</div>
        </div>
        <div className={[global.prosBox, global.multiplatformAccess].join(' ')}>
          <div className={global.prosIcon}>
            <div className={global.prosIconWidth}>
              <img src={alwaysConnected} alt="Always connected" />
            </div>
          </div>
          <div className={global.prosTitle}>Always Connected</div>
          <div className={global.prosBlurb}>No pairing needed. Sensors Automatically communicate with through all Cloud Connectors.</div>
        </div>
        <div className={[global.prosBox, global.yourWayEveryWay].join(' ')}>
          <div className={global.prosIcon}>
            <div className={global.prosIconWidth}>
              <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_148_10117" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="52" height="52">
                  <rect width="52" height="52" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_148_10117)">
                  <path d="M34.2334 46.0417L33.4209 42.6833C32.1209 41.7444 31.1008 40.5799 30.3605 39.1896C29.6202 37.7993 29.2501 36.2917 29.2501 34.6667C29.2501 33.0417 29.6202 31.534 30.3605 30.1437C31.1008 28.7535 32.1209 27.5889 33.4209 26.65L34.2334 23.2917C34.3417 22.7861 34.5945 22.3889 34.9917 22.1C35.389 21.8111 35.8404 21.6667 36.3459 21.6667H41.6542C42.1598 21.6667 42.6112 21.8111 43.0084 22.1C43.4056 22.3889 43.6584 22.7861 43.7667 23.2917L44.5792 26.65C45.8792 27.5889 46.8994 28.7535 47.6397 30.1437C48.3799 31.534 48.7501 33.0417 48.7501 34.6667C48.7501 36.2917 48.3799 37.7993 47.6397 39.1896C46.8994 40.5799 45.8792 41.7444 44.5792 42.6833L43.7667 46.0417C43.6584 46.5472 43.4056 46.9444 43.0084 47.2333C42.6112 47.5222 42.1598 47.6667 41.6542 47.6667H36.3459C35.8404 47.6667 35.389 47.5222 34.9917 47.2333C34.5945 46.9444 34.3417 46.5472 34.2334 46.0417ZM39.0001 40.0833C40.5167 40.0833 41.7987 39.5597 42.8459 38.5125C43.8931 37.4653 44.4167 36.1833 44.4167 34.6667C44.4167 33.15 43.8931 31.868 42.8459 30.8208C41.7987 29.7736 40.5167 29.25 39.0001 29.25C37.4834 29.25 36.2015 29.7736 35.1542 30.8208C34.107 31.868 33.5834 33.15 33.5834 34.6667C33.5834 36.1833 34.107 37.4653 35.1542 38.5125C36.2015 39.5597 37.4834 40.0833 39.0001 40.0833ZM8.66675 24.05V13.8125C8.66675 12.9097 8.92855 12.0972 9.45216 11.375C9.97578 10.6528 10.6529 10.1292 11.4834 9.80416L24.4834 4.92916C24.989 4.7486 25.4945 4.65833 26.0001 4.65833C26.5056 4.65833 27.0112 4.7486 27.5167 4.92916L40.5167 9.80416C41.3473 10.1292 42.0244 10.6528 42.548 11.375C43.0716 12.0972 43.3334 12.9097 43.3334 13.8125V15.1667C43.3334 15.7805 43.1258 16.2951 42.7105 16.7104C42.2952 17.1257 41.7806 17.3333 41.1667 17.3333C40.5529 17.3333 40.0383 17.1257 39.623 16.7104C39.2077 16.2951 39.0001 15.7805 39.0001 15.1667V13.8125L26.0001 8.93749L13.0001 13.8125V24.05C13.0001 28.3472 14.1556 32.2833 16.4667 35.8583C18.7779 39.4333 21.9556 41.8528 26.0001 43.1167C26.2529 43.0444 26.4876 42.9722 26.7042 42.9C26.9209 42.8278 27.1376 42.7375 27.3542 42.6292C27.8959 42.3403 28.4466 42.2951 29.0063 42.4937C29.5661 42.6924 29.9904 43.0625 30.2792 43.6042C30.5681 44.1458 30.6133 44.6965 30.4147 45.2562C30.2161 45.816 29.8459 46.2403 29.3042 46.5292C29.0154 46.6736 28.7355 46.8 28.4647 46.9083C28.1938 47.0167 27.914 47.1069 27.6251 47.1792C27.3362 47.2514 27.0654 47.3146 26.8126 47.3687C26.5598 47.4229 26.289 47.45 26.0001 47.45C25.7112 47.45 25.4404 47.4229 25.1876 47.3687C24.9348 47.3146 24.664 47.2514 24.3751 47.1792C19.6084 45.5542 15.7987 42.5389 12.9459 38.1333C10.0931 33.7278 8.66675 29.0333 8.66675 24.05Z" fill="#1C1B1F" />
                </g>
              </svg>
            </div>
          </div>
          <div className={global.prosTitle}>Lifetime Warranty</div>
          <div className={global.prosBlurb}>Built to last. If it ever breaks, we’ll make it right.</div>
        </div>
      </div>

      <div className={global.learnMoreContainer}>
        <a className={global.learnMoreButton} href={PathConstants.TemperatureMonitoring}>
          Learn more
        </a>
      </div>

      <TemperatureSalesBox />

        <div className={global.homeh2}>
        <h2>VSBL Provides Team Members with tools and information they need to do their jobs well</h2>
        </div>

        <div className={global.centerVideoFrame}>
          <div className={global.centerVideoFrameContainer}>
            <iframe
              src="https://www.youtube.com/embed/7eBvSTewIBQ?si=L5SIh0IqGoGTBUSY"
              title="Transform your Restaurant with VSBL"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen>
            </iframe>
            </div>
        </div>

        <div className={global.homeh2}>
          <h2>Providing Team Members with tools and information they need to do their jobs well</h2>
        </div>

        <div className={global.prosList}>
          <div className={[global.prosBox, global.yourWayEveryWay].join(' ')}>
            <div className={global.prosIcon}>
              <div className={global.prosIconWidth}>
                <img src={bilingualExperience} />
              </div>
            </div>
            <div className={global.prosTitle}>Bilingual Experience</div>
            <div className={global.prosBlurb}>Bring inclusivity and enjoy VSBL in both English and Spanish</div>
          </div>
          <div className={[global.prosBox, global.multiplatformAccess].join(' ')}>
            <div className={global.prosIcon}>
              <div className={global.prosIconWidth}>
                <img src={multiplatformAccess} />
              </div>
            </div>
            <div className={global.prosTitle}>Multi-Platform Access</div>
            <div className={global.prosBlurb}>Available on iOS, Android, and desktop devices</div>
          </div>
          <div className={[global.prosBox, global.bilingualExperience].join(' ')}>
            <div className={global.prosIcon}>
              <div className={global.prosIconWidth}>
                <img src={yourWayEveryWay} alt="Always connected" />
              </div>
            </div>
            <div className={global.prosTitle}>Your Way, Every Way</div>
            <div className={global.prosBlurb}>Customize and edit from your phone anywhere, anytime</div>
          </div>
        </div>

        <div className={global.featuresDisplayBoxContainer}>
          <div className={global.featuresDisplayBox}>
            <div className={global.displayBoxTopNav}>
              <ul>
                <li className={activeFeatureDisplayBox === "shifts" ? global.featureActiveTab : ''} rel="shifts" onClick={() => displayBoxHandler('shifts')}>Shifts</li>
                <li className={activeFeatureDisplayBox === "setups" ? global.featureActiveTab : ''} rel="setups" onClick={() => displayBoxHandler('setups')}>Setups</li>
                <li className={activeFeatureDisplayBox === "accountability" ? global.featureActiveTab : ''} rel="accountability" onClick={() => displayBoxHandler('accountability')}>Accountability</li>
                <li className={activeFeatureDisplayBox === "vendors" ? global.featureActiveTab : ''} rel="vendors" onClick={() => displayBoxHandler('vendors')}>Vendors</li>
                <li className={activeFeatureDisplayBox === "reporting" ? global.featureActiveTab : ''} rel="reporting" onClick={() => displayBoxHandler('reporting')}>Reporting</li>
                <li className={activeFeatureDisplayBox === "rewards" ? global.featureActiveTab : ''} rel="rewards" onClick={() => displayBoxHandler('rewards')}>Rewards</li>
                <li className={activeFeatureDisplayBox === "checklistsAndTasks" ? global.featureActiveTab : ''} rel="checklistsAndTasks" onClick={() => displayBoxHandler('checklistsAndTasks')}>Checklists &amp; Tasks</li>
                <li className={activeFeatureDisplayBox === "waste" ? global.featureActiveTab : ''} rel="waste" onClick={() => displayBoxHandler('waste')}>Waste</li>
                <li className={activeFeatureDisplayBox === "homeScreen" ? global.featureActiveTab : ''} rel="homeScreen" onClick={() => displayBoxHandler('homeScreen')}>Home Screen</li>
                <li className={activeFeatureDisplayBox === "teamAndScoreboard" ? global.featureActiveTab : ''} rel="teamAndScoreboard" onClick={() => displayBoxHandler('teamAndScoreboard')}>Team &amp; Scoreboard</li>
              </ul>
            </div>
            <FeatureDisplayBoxInner activeTab={activeFeatureDisplayBox}/>
          </div>
        </div>


        <a id="testimonials"></a>
        <div className={[global.homeh2, global.testimonialsSection].join(' ')}>
          <h2>What our Users are Saying</h2>
          <p>Discover how our platform has had a positive impact on the lives of our users</p>
        </div>
        <div className={global.testimonialContainer}>
          <div className={global.testimonial}>
            <div className={global.testimonialTopDiv}>
              {/*<div className={global.testimonialPic}><img src={headshot1} alt="Testimonial Picture"></img></div>*/}
              <div className={global.testimonialTopDivRightSide}>
                <div className={global.testimonialFullName}>Gabbie Puente</div>
                <div className={global.testimonialLocation}>Chick-fil-A N. Tarrant Pkwy</div>
              </div>
            </div>
            <div className={global.testimonialBottomDiv}>
              <div className={global.comment}>VSBL is a phenomenal tool for restaurant leaders and teams to help execute procedural disciplines and standards in all areas through creating checklists, shifts, and tasks. It brings visibility and accountability to light by being able to review and evaluate each team member’s performance all in one app. We get to recognize our team members on a daily basis in a social forum for everyone to encourage.</div>
              {/*<div className={global.testimonialRating}><GradeIcon /><GradeIcon /><GradeIcon /><GradeIcon /><GradeIcon /></div>*/}
            </div>
          </div>

          <div className={global.testimonial}>
            <div className={global.testimonialTopDiv}>
              {/*<div className={global.testimonialPic}><img src={headshot2} alt="Testimonial Picture"></img></div>*/}
              <div className={global.testimonialTopDivRightSide}>
                <div className={global.testimonialFullName}>Canaan Barber</div>
                <div className={global.testimonialLocation}>Chick-fil-A Heritage Towne Crossing</div>
              </div>
            </div>
            <div className={global.testimonialBottomDiv}>
              <div className={global.comment}>When I was first shown the VSBL demo video, I immediately was like, "I HAVE TO HAVE THAT!" All of the features were things we were lacking in our restaurant in one app! It has truly made accountability, recognition, and communication 1000% better than it was before. Also, the VSBL team has been more than amazing, communication, taking feedback and ideas, quick to respond if needed. VSBL has truly elevated my work experience and my teams! Thank you!</div>
              {/*<div className={global.testimonialRating}><GradeIcon /><GradeIcon /><GradeIcon /><GradeIcon /><GradeIcon /></div>*/}
            </div>
          </div>

          <div className={global.testimonial}>
            <div className={global.testimonialTopDiv}>
              {/*<div className={global.testimonialPic}><img src={headshot3} alt="Testimonial Picture"></img></div>*/}
              <div className={global.testimonialTopDivRightSide}>
                <div className={global.testimonialFullName}>TJ St. Romain </div>
                <div className={global.testimonialLocation}>Multi-Restaurant Chick-fil-A Operator</div>
              </div>
            </div>
            <div className={global.testimonialBottomDiv}>
              <div className={global.comment}>The VSBL app encourages leadership engagement around the fundamental disciplines and procedures inside my restaurant. Being able to see the completion of daily tasks and checklists improves the accountability from my leaders to team members. This app helps ensure standards are being met in all areas including training, food safety, daily operational practices, and more.</div>
              {/*<div className={global.testimonialRating}><GradeIcon /><GradeIcon /><GradeIcon /><GradeIcon /><GradeIcon /></div>*/}
            </div>
          </div>
        </div>

        <div className={[global.homeh2, global.whatYouWillGet].join(' ')}>
          <h2>With VSBL, you'll get:</h2>
        </div>
        <div className={global.whatYouWillGetContainer}>
          <div className={global.whatYouGet}>
            <div className={global.whatYouGetTop}><div className={global.whatYouGetSVG}><CheckCircleIcon /></div><div className={global.whatYouGetTitle}>1-on-1 Onboarding</div></div>
            <div className={global.whatYouGetBottom}>At VSBL, we provide personalized onboarding to ensure your success from day one</div>
          </div>
          <div className={global.whatYouGet}>
            <div className={global.whatYouGetTop}><div className={global.whatYouGetSVG}><CheckCircleIcon /></div><div className={global.whatYouGetTitle}>Community Support</div></div>
            <div className={global.whatYouGetBottom}>Experience dedicated community support, where you’ll never feel alone on your journey</div>
          </div>
          <div className={global.whatYouGet}>
            <div className={global.whatYouGetTop}><div className={global.whatYouGetSVG}><CheckCircleIcon /></div><div className={global.whatYouGetTitle}>Restaurant People</div></div>
            <div className={global.whatYouGetBottom}>Every person on our Community Team worked in the restaurant before joining VSBL</div>
          </div>
        </div>
      </div>
  );
}

export default Home;